<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">Transferência entre contas</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Preencha os dados abaixo para cadastrar a transferência.
                </p>
            </div>
        </div>

        @if (isLoading) {
        <div class="section-container">
            <div class="row g-3 mt-1">
                <div class="col-12 col-xl-6">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-6">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
            </div>
            <div class="row g-3">
                <div class="col-12 col-xl-6">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-6">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
            </div>
        </div>

        <div class="section-container">
            <app-loading-box height="320" width="100%" marginTop="0"></app-loading-box>
        </div>
        } @else {
        <form [formGroup]="form" class="transferencia-form">
            <div class="row g-3 mb-3">
                <div class="col-12 col-xl-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Data</mat-label>
                        <input matInput [matDatepicker]="pickerData" formControlName="data" placeholder="DD/MM/AAAA"
                            (input)="onDateInput($event)">
                        <mat-datepicker-toggle matIconSuffix [for]="pickerData"></mat-datepicker-toggle>
                        <mat-datepicker #pickerData></mat-datepicker>
                        @if (form.get('data')?.hasError('required')) {
                        <mat-error>Este campo é obrigatório.</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="col-12 col-xl-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Valor (R$)</mat-label>
                        <input matInput formControlName="valor" [currencyMask]="currencyMask">
                        @if (form.get('valor')?.hasError('required') || form.get('valor')?.hasError('min')) {
                        <mat-error>Informe um valor maior que zero.</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>

            <div class="row g-3 mb-4">
                <div class="col-12 col-xl-6">
                    <app-select-pesquisavel [control]="idContaOrigemControl" [offlineList]="contaOptions"
                        [preloadedOptions]="contaOptions" [idField]="'id'" [nameField]="'descricao'"
                        [label]="'Conta de Origem'" [isOptional]="true">
                    </app-select-pesquisavel>
                    @if (saldoContaOrigem !== null) {
                    <div class="saldo-conta" [class.saldo-negativo]="saldoContaOrigem < 0">
                        Saldo atual conta {{nomeContaOrigem}}: {{ saldoContaOrigem | currency:'BRL':'R$ ':'1.2-2':'pt-BR' }}
                    </div>
                    }
                </div>

                <div class="col-12 col-xl-6">
                    <app-select-pesquisavel [control]="idContaDestinoControl" [offlineList]="contaDestinoOptions"
                        [preloadedOptions]="contaDestinoOptions" [idField]="'id'" [nameField]="'descricao'"
                        [label]="'Conta de Destino'" [isOptional]="true">
                    </app-select-pesquisavel>
                    @if (saldoContaDestino !== null) {
                    <div class="saldo-conta" [class.saldo-negativo]="saldoContaDestino < 0">
                        Saldo atual conta {{nomeContaDestino}}: {{ saldoContaDestino | currency:'BRL':'R$ ':'1.2-2':'pt-BR' }}
                    </div>
                    }
                </div>
            </div>

            <div class="editor-section mb-4">
                <label class="field-label">Histórico / Descrição</label>
                <div class="editor-container">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="historicoHtml"
                        placeholder="Escreva aqui as observações adicionais..."></ngx-editor>
                </div>
                @if (form.get('historicoHtml')?.hasError('required') && form.get('historicoHtml')?.touched) {
                <div class="field-error">Este campo é obrigatório.</div>
                }
            </div>
        </form>
        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading || form.invalid" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
